import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './bottomBar.css'
import { getBottomToolbarActions } from '../../../redux/availableActions/selectors'
import { ToolbarContainer } from '../Toolbar/Toolbar'
import { FilterContainer } from '../Toolbar/Slider/Filter/Filter'
import { ZoomContainer } from '../Toolbar/Slider/Zoom/Zoom'
import Toggle from 'material-ui/Toggle'
import { withTranslation } from 'react-i18next'
import { ShareContainer } from '../AppBar/Share/Share'

class BottomBar extends Component {

    static propTypes = {
        zoomAction: PropTypes.func.isRequired,
        contrastAction: PropTypes.func.isRequired,
        contrastValue: PropTypes.number.isRequired,
        brightnessAction: PropTypes.func.isRequired,
        brightnessValue: PropTypes.number.isRequired,
        onInvertChange: PropTypes.func.isRequired,
        isInvertActive: PropTypes.bool.isRequired,
        isImageSettingAsideDisplayed: PropTypes.bool.isRequired,
        isZoomAsideDisplayed: PropTypes.bool.isRequired,
        isSocialSharingAsideDisplayed: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired,
    }

    render()
    {

        const {
            zoomAction, scale,
            contrastAction, contrastValue,
            brightnessAction, brightnessValue,
            onInvertChange, isInvertActive,
            isImageSettingAsideDisplayed,
            isZoomAsideDisplayed,
            isSocialSharingAsideDisplayed,
            t
        } = this.props

        return (
            <div className="bottom-bar print-hidden">

                <ToolbarContainer type='horizontal' name='bottom' itemsSupplier={getBottomToolbarActions} />
                        <div className="bottom-bar-aside">

                            <div className={classNames('share', 'wrapper', 'animate', {'hidden-vertical': ! isSocialSharingAsideDisplayed  })}>
                                <ShareContainer />
                            </div>

                            <div className={classNames('zoom', 'wrapper', 'animate', {'hidden-vertical': ! isZoomAsideDisplayed })}>
                                <ZoomContainer
                                    changeAction={zoomAction}
                                    name={t('visualizer:toolbar.bottom.filters.imageSet.filters.invert')}
                                    label={t('visualizer:toolbar.bottom.filters.zoom.label')}
                                    value={scale}
                                />
                            </div>

                            <div className={classNames('filter', 'wrapper', 'animate', {'hidden-vertical': ! isImageSettingAsideDisplayed })}>
                                <FilterContainer
                                    min={-100} max={100} step={1}
                                    changeAction={contrastAction}
                                    name="contrast"
                                    label={t('visualizer:toolbar.bottom.filters.imageSet.filters.contrast')}
                                    value={contrastValue}
                                />
                                <FilterContainer
                                    min={-1} max={1} step={0.01}
                                    changeAction={brightnessAction}
                                    name="brightness"
                                    label={t('visualizer:toolbar.bottom.filters.imageSet.filters.brightness')}
                                    value={brightnessValue}
                                />
                                <Toggle
                                    onToggle={onInvertChange}
                                    label={t('visualizer:toolbar.bottom.filters.imageSet.filters.invert')}
                                    toggled={isInvertActive}
                                    className={classNames('settings', 'invert-settings')}
                                />
                            </div>
                        </div>




            </div>
        )
    }
}

export default withTranslation()(BottomBar)
